import { signal } from "./deps.ts";
import { ResponseStoreType } from "./types.ts";

export const ResponseStore = signal<ResponseStoreType>(null);
